<template>


  <div class="wrapper">

    <v-sidebar activeNavItem="contact"></v-sidebar>

    <div class="main-panel">

      <v-navbar :title="'Contacts'"></v-navbar>

      <div class="content">
          <div class="container-fluid">
              <div class="row">
                  <div class="col-md-12">
                      <div class="card data-tables">
                          <div class="card-body table-striped table-no-bordered table-hover dataTable dtr-inline table-full-width">
                              <div class="toolbar text-right" style="padding-right: 15px;">
                                  <!-- Here you can write extra buttons/actions for the toolbar -->
                                  <button class="btn btn-success btn-wd" v-on:click="addContact()"><i class="fa fa-user"></i> Add Contact</button>
                              </div>
                              <span class="loading text-muted">&nbsp;&nbsp;Loading...</span>
                              <div class="fresh-datatables" style="display:none">
                                  <table id="datatables_contacts" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                                    <thead>
                                      <tr>
                                        <th>Email</th>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>Website</th>
                                        <th>Company</th>
                                        <th>Phone Number</th>
                                        <th>Address</th>
                                      </tr>
                                    </thead>
                                  </table>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button class="btn btn-success btn-wd" v-on:click="addContact()"><i class="fa fa-user"></i> Add Contact</button>
                </div>
              </div>
          </div>

      </div>
      <footer class="footer">
        <div class="container">
          <nav>
            <p class="copyright text-center">
              &copy; 2020 Raefton
            </p>
          </nav>
        </div>
      </footer>
    </div>
  </div>



</template>

<script>
import apiService from '../../services/api.service'
import router from '../../router'

import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'

import { checkResponseErrors } from '../../utils/http'

var rows = [ ]
export default {
  name: 'ContactView',
  components: {
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer
  },
  data: function () {
    return {
      rows: rows,
      filterinput: ''
    }
  },
  async mounted() {
    // Refresh List of Contacts
    // Authenticated so refresh local storage
    const entityResponse = await apiService.get('/entity/list')
    if(await checkResponseErrors(entityResponse)) return;
    
    const ents = entityResponse.data.Result

    // Get a list of all relationships
    const rowlen = rows.length
    for (var j = 0; j < rowlen; j++) {
      rows.pop()
    }
    for (var i = 0; i < ents.length; i++) {        
      const rel = ents[i]
      
      let companyWebsite = rel.companyObject && rel.companyObject.website? rel.companyObject.website : ""
      if (companyWebsite != null && companyWebsite.length > 0 && companyWebsite.toLowerCase().indexOf("http") != 0){
        companyWebsite = "http://" + companyWebsite;
      }

      const companyPhone = rel.companyObject && rel.companyObject.phone? rel.companyObject.phone : "-"

      // builds a table row from an asset
      rows.push({
        email: rel.email,
        name: rel.name || "",
        type: rel.type || "",
        website: (companyWebsite != "")? `<a href="${companyWebsite}" target="_blank">${companyWebsite}</a>` : "",
        companyDivision: `${rel.company || ""} ${rel.division || ""}`,
        phone: `${rel.phonecell || ""}<br><small class='text-muted'>Office: ${rel.phoneoffice || "-"}<br>Company: ${companyPhone}</small>`,
        fullAddress: `${rel.address || "-"}, ${rel.city || "-"}, ${rel.province || "-"}<br>${rel.postal || "-"}<br>${rel.country || "-"}`,
      });
    }

    initDataTable(rows);
  },

  methods: {
    addContact: function () {
      router.push('/contact/add')
    }
  }
}


function initDataTable(rows) {
  $('#datatables_contacts').DataTable({
    "data": rows,
    "columns": [
      { "data": "email" },
      { "data": "name" },
      { "data": "type" },
      { "data": "website" },
      { "data": "companyDivision" },
      { "data": "phone" },
      { "data": "fullAddress" },
    ],
    "pagingType": "full_numbers",
    "lengthMenu": [
      [10, 25, 50, -1],
      [10, 25, 50, "All"]
    ],
    "order": [[ 1, "asc" ]],
    retrieve: true,
    stateSave: false,
    responsive: {
      details: false
    },
    language: {
      search: "_INPUT_",
      searchPlaceholder: "Search records",
    },
  });
  $(".fresh-datatables").show();
  $(".loading").hide();
}

</script>



// WEBPACK FOOTER //
// view.vue?308732ae